import MuiSwitch, { SwitchProps } from '@mui/material/Switch';
import FormControl from '../FormControl';
import FormControlLabel from '../FormControlLabel';
import FormHelperText from '../FormHelperText';

export interface ISwitchProps extends SwitchProps {
  label?: string | number | React.ReactElement;
  error?: boolean;
  helperText?: string;
}

const Switch = (props: ISwitchProps): JSX.Element => {
  return <FormControl error={props.error} fullWidth size="small" sx={props.sx} disabled={props.disabled}>
    <FormControlLabel disabled={props.disabled}
      control={
        <MuiSwitch
          {...props}
          size="small"
        ></MuiSwitch>
      }
      label={props.label || ""}
      labelPlacement="end"
    ></FormControlLabel>
    <FormHelperText error={props.error}>{props.helperText}</FormHelperText>
  </FormControl>
};

export default Switch;
